<template>
    <modal
        :value="value"
        :max-width="650"
        title="Permissões de Estabelecimento gerenciáveis pelo Parceiro"
        content-class="modal modal-round "
        @input="emitInput"
    >
        <section>
            <loading v-if="loading" class="loader" />
            <toggles-section
                v-else
                :value="manageablePermissions"
                :permissions="permissions"
                @toggle="togglePermission"
            >
            </toggles-section>
        </section>
    </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import EventBus from "@packages/event-bus";
import TogglesSection from "@components/user-modal/components/sections/TogglesSection.vue";
import Loading from "@/components/generic/Loading.vue";

export default {
    components: {
        Modal,
        TogglesSection,
        Loading,
    },

    data() {
        return {
            permissions: [],
            loading: false,
        };
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
        manageablePermissions: {
            type: Array,
            required: true,
        },
        partnerId: {
            type: Number,
            required: true,
        },
    },

    computed: {
        isPartnerLogged() {
            return (
                this.$store.state.users.user != null &&
                this.$store.state.users.user.tipo === "PARCEIRO"
            );
        },
    },

    methods: {
        emitInput(value) {
            this.$emit("input", value);
        },
        async loadPermissions() {
            this.permissions = await this.$api.account.listPermissions({
                accountType: "ESTABELECIMENTO",
            });
        },
        async togglePermission(permissionKey) {
            try {
                const response =
                    await this.$api.partners.toggleEstablishmentManageablePermission(
                        {
                            partnerId: this.partnerId,
                            permissionKey,
                        }
                    );
                this.$emit("on-toggle", {
                    permission: permissionKey,
                    active: response,
                });
                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: "Permissão alterada com sucesso",
                });
            } catch (error) {
                console.log(error);
            }
        },
    },

    created() {
        this.loading = true;
        this.loadPermissions().finally(() => {
            this.loading = false;
        });
    },
};
</script>

<style scoped>
section {
    display: flex;
    justify-content: center;
}
</style>
